{
  "localSettings": {
    "ancillaries": {
      "productCard": {
        "originalPriceLabel": "Original price"
      }
    }
  },
  "ancillaries": {
    "perBooking": "/ booking",
    "bundle": {
      "conflictingBundle": "",
      "serviceIncludedInBundleNotification": "",
      "upsellCard": {
        "seatWifi": {
          "buttonText": {
            "addCombo": "Add combo",
            "added": "Added"
          },
          "addCombo": {
            "productCardTitle": "Seat + {productName}",
            "title": "10% off when booked together",
            "image": {
              "alt": "",
              "contentId": 3560630,
              "data": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg",
              "teaserTitle": "",
              "responsiveImageLinksData": {
                "landscape_ratio21x9": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=4000&height=1714&x=0&y=791"
                },
                "landscape_ratio16x9": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=4000&height=2250&x=0&y=278"
                },
                "portrait_ratio1x1": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=2666&height=2666&x=681&y=0"
                },
                "landscape_ratio4x3": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=3555&height=2666&x=445&y=0"
                }
              }
            }
          },
          "addProduct": {
            "title": "Get internet for less withn a seat",
            "image": {
              "alt": "",
              "contentId": 3560630,
              "data": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg",
              "teaserTitle": "",
              "responsiveImageLinksData": {
                "landscape_ratio21x9": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=4000&height=1714&x=0&y=791"
                },
                "landscape_ratio16x9": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=4000&height=2250&x=0&y=278"
                },
                "portrait_ratio1x1": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=2666&height=2666&x=681&y=0"
                },
                "landscape_ratio4x3": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=3555&height=2666&x=445&y=0"
                }
              }
            }
          }
        }
      },
      "toggle": {
        "personalized": {
          "comboOfferText": "Personalized combo"
        }
      },
      "bundlePriceLabel": "Bundle price",
      "discountLabel": "{percentage}% discount",
      "serviceCard": {
        "inCartTag": "In cart",
        "tierBenefitTag": "Benefit"
      }
    },
    "lounge": {
      "detailsLinkTitle": "Lounge details"
    },
    "quota": {
      "quotaExhausted": "That's the last {service} on this flight.",
      "quotaExhaustedByOtherPassengers": "You've already added the last {service} for another passenger.",
      "onlyQuotaLeft": {
        "singular": "Only one left",
        "plural": "{quota} left"
      },
      "quotaLeft": {
        "singular": "1 left",
        "plural": "{quota} left"
      },
      "noQuotaLeft": "None left"
    }
  },
  "paxDetails": {
    "reviewTitle": {
      "single": "Review passenger details",
      "multi": "Review and add details"
    }
  },
  "purchase": {
    "success": {
      "stayInTouch": {
        "default": {
          "title": "We’ll send updates to help you prepare",
          "description": "<p>You'll receive reminders, tips and offers for your upcoming trip by email.</p><p>You can change your communication preferences anytime in your <a href='https://www.finnair.com/fi-en/my-finnair-plus/update-profile?section=marketing-preferences' target='_blank' rel='noopener noreferrer'>Finnair Plus profile</a>.</p>"
        },
        "multiPassenger": {
          "title": "We’ll send updates to help you prepare",
          "description": "<p>You'll receive reminders, tips and offers for your upcoming trip by email. Others in this booking may also receive them, based on their communication preferences.</p><p>You can change your preferences anytime in your <a href='https://www.finnair.com/fi-en/my-finnair-plus/update-profile?section=marketing-preferences' target='_blank' rel='noopener noreferrer'>Finnair Plus profile</a>.</p>"
        },
        "emailMismatch": {
          "title": "We’ll send updates to help you prepare",
          "description": "<p>You'll receive reminders and tips for your upcoming trip to the email address used when booking: {email}.</p><p>You can manage your communication preferences using the link in the email footer.</p>"
        },
        "multiPassengerEmailMismatch": {
          "title": "We’ll send updates to help you prepare",
          "description": "<p>You'll receive reminders and tips for your upcoming trip to the email address used when booking: {email}. Others in this booking may also receive them, based on their communication preferences.</p><p>You can manage your preferences using the link in the email footer.</p>"
        }
      }
    }
  }
}
